<template>
    <Container
        :provience="provience"
        ref="container"
        :result="result"
        :basicCriterion="basicCriterion"
        :name="name"
        @submit="submit"
        @handleProvienceChange="handleProvienceChange"
        >
        <template #form>
            <el-form 
                class="otherForm calculatorForm" 
                :model="form" 
                ref="form" 
                label-width="180px" 
                style="width: 500px"
                >
                <el-form-item 
                    v-for="(item, index) in form.formItemList"
                    v-if="item.showFormItem && item.describeType != '固定结果'"
                    :key="item.id"
                    :label="item.describeName" 
                    :prop="'formItemList.' + index + '.describeValue'"
                    :rules="{
                        required: true, 
                        message: `${item.describeName}不能为空`, 
                        trigger: 'blur'
                    }"
                    >
                    <span v-if="item.describeType == '固定文字'">
                        {{ item.describeValue }}
                    </span>
                    <el-input-number 
                        v-if="item.describeType == '数字' || 
                            !item.describeType || 
                            item.describeType == '固定数字' || 
                            item.describeType == '树形下拉数字选项' ||
                            item.describeType == '树形下拉选项' ||
                            item.describeType == '下拉数字选项' ||
                            item.describeType == '树形下拉关联选项' ||
                            item.describeType == '树形下拉多选选项'
                            "
                        :min="0" 
                        v-model="item.describeValue"
                        style="width: 200px"
                        >
                    </el-input-number>  
                    <el-select 
                        v-if="item.describeType == '树形下拉文字选项'"
                        v-model="item.describeValue"
                        style="width: 200px"
                        disabled
                        >
                    </el-select>
                    <span >
                    </span>
                    <el-input-number 
                        v-if="item.describeType == '0-1'"
                        :min="0" 
                        :max="1" 
                        :step="0.1"
                        v-model="item.describeValue"
                        style="width: 200px"
                        >
                    </el-input-number>
                    <el-input-number 
                        v-if="item.describeType == '百分比'"
                        :min="0" 
                        :max="100" 
                        :step="1"
                        v-model="item.describeValue"
                        style="width: 200px"
                        >
                    </el-input-number>
                    <el-select
                        v-if="item.describeType == '下拉选项' || item.describeType == '下拉关联选项'"
                        v-model="item.describeValue"
                        @change="handleSelectChange($event, index)"
                        >
                        <el-option
                            v-for="item in item.describeOptionList"
                            :key="item.dictName"
                            :label="item.dictName"
                            :value="item.dictCode"
                            > 
                            <template>
                                <div>{{ item.dictName }}</div>
                                <div 
                                    class="dictDetail"
                                    v-if="item.dictDetail"
                                    v-html="item.dictDetail"
                                    >
                                </div>
                            </template>
                        </el-option>
                    </el-select>
                    <el-cascader
                        v-if="item.describeType == '下拉树形关联选项'"
                        v-model="item.describeShowValue"
                        :options="item.describeOptionList"
                        :props="{ 
                            label: 'dictName',
                            value: 'dictCode',
                        }"
                        @change="handleCascaderSelectChange($event, index)"
                        >
                    </el-cascader>
                    <el-select 
                        v-if="item.describeType == '下拉多选'"
                        v-model="item.describeCode"
                        @change="handleSelectChange($event, index)"
                        multiple 
                        collapse-tags
                        >
                        <el-option 
                            v-for="item in item.describeOptionList"
                            :key="item.dictName"
                            :label="item.dictName"
                            :value="item.dictCode"
                            >
                        </el-option>
                    </el-select>
                    {{ item.describeUnit }}
                    <el-button 
                        v-if="
                            item.describeType == '树形下拉选项' || 
                            item.describeType == '树形下拉数字选项' || 
                            item.describeType == '树形下拉文字选项' || 
                            item.describeType == '下拉数字选项' || 
                            item.describeType == '树形下拉关联选项' ||
                            item.describeType == '树形下拉多选选项' 
                            "
                        type="primary"
                        size="mini"
                        @click="handleSelectDialog(item, index)"
                        >
                        点击选择
                    </el-button>
                    <Reference
                        v-if="item.priceDescribe"
                        :priceDescribe="item.priceDescribe"
                        />
                </el-form-item>
                <br/>
                <el-dialog
                    :title="dialogTitle"
                    :visible.sync="dialogVisible"
                    width="700"
                    >
                    <div class="dialogBox">
                        <el-tree
                            ref="tree"
                            :data="optionsList"
                            node-key="id"
                            :show-checkbox="currentItemType == '树形下拉多选选项'"
                            @check-change="handleCheckChange"
                            >
                            <div class="custom-tree-node" slot-scope="{ node, data }">
                                <div class="dictContent">
                                    <div class="dictName">{{ data.dictName }}</div>
                                    <div 
                                        class="fr dictCode"
                                        v-if="!(data.children && data.children.length > 0)"
                                        >
                                        <span class="mr20">
                                            {{ data.dictCode }}
                                        </span>
                                        <el-button
                                            v-if="currentItemType != '树形下拉多选选项'"
                                            type="text"
                                            size="mini"
                                            @click="handleCascaderChange(data)"
                                            >
                                            选择
                                        </el-button>
                                    </div>
                                </div>
                                <div 
                                    class="dictDetail"
                                    v-if="data.dictDetail"
                                    v-html="data.dictDetail"
                                    >
                                </div>
                            </div>
                        </el-tree>
                    </div>
                    <span 
                        v-if="currentItemType == '树形下拉多选选项'"
                        slot="footer" 
                        class="dialog-footer"
                        >
                        <el-button 
                            @click="dialogVisible = false"
                            >
                            取 消
                        </el-button>
                        <el-button 
                            type="primary" 
                            @click="handleSure"
                            >
                            确 定
                        </el-button>
                    </span>
                </el-dialog>
            </el-form>
        </template>
    </Container>
</template>
<script>
import Container from './layout/Container'
import Reference from './layout/Reference.vue'

export default {
    components: {
        Container,
        Reference
    },
    props: {
        id: {
            type:String,
            default: '1'
        },
        name: {
            type:String,
            default: ''
        },
        index: {
            type:String,
            default: ''
        },
        serviceProjectType: {
            type:String,
            default: ''
        },
        provience: {
            type:String,
            default: ''
        },
    },
    data() {
        return {
            dialogVisible: false,
            dialogTitle: '',
            optionsList: [],
            currentIndex: 0,

            basicCriterion: {},
            result: {
                otherCost: ''
            },
            selectData: [],
            requiredFieldsObj: {},
            form: {
                formItemList: []
            },
            cityName: '',
            checkFormItem: false,
            currentItemType: ''
        }
    },
    methods: {
        handleSelectDialog(item, index) {
            this.currentItemType = item.describeType
            this.currentIndex = index
            this.dialogTitle = item.describeName
            this.dialogVisible = true
            this.optionsList = item.describeOptionList
        },
        handleCascaderChange(item) {
            this.form.formItemList[this.currentIndex].describeValue = item.dictCode
            this.checkShowFormItemFn()
            this.dialogVisible = false
        },

        handleSelectChange(e, index) {
            console.log(e, index)
            this.form.formItemList[index].describeValue = e.toString()
            this.checkShowFormItemFn()
        },

        // 下拉树形关联选项
        handleCascaderSelectChange(e, index) {
            this.form.formItemList[index].describeValue = e[e.length - 1]
            this.checkShowFormItemFn()
        },

        handleSure() {
            this.dialogVisible = false
            let checkedList = this.$refs.tree.getCheckedNodes(true)
            if(checkedList.length == 0) return
            let result = 0
            if(checkedList.length > 1){
                result = checkedList.reduce((pre, cur) => {
                    return pre + cur.dictCode * 1
                }, 0) - checkedList.length + 1
                result = result.toFixed(2)
            }else if(checkedList.length == 1){
                result = checkedList[0].dictCode
            }
            this.form.formItemList[this.currentIndex].describeValue = result
        },

        handleCheckChange(data, checked, indeterminate) {
            console.log(data, checked, indeterminate);
        },

        getSpecialFormItem(targetNameList, type) {
            // 判断是否有打折系数但是没有展示
            let result = this.form.formItemList.filter(item => {
                return targetNameList.includes(item[type])
            }).filter(item => item.showFormItem)
            if(result.length > 0){
                return result[0].describeValue
            }else{
                return '/'
            }
        },

        getDiscountRatio() {
            // 判断是否有打折系数但是没有展示
            let targetNameList = [
                '标准取费打折系数',
                '打折系数',
                '比例系数'
            ]
            return this.getSpecialFormItem(targetNameList, 'describeName')
        },

        // 打折系数按照百分比展示
        formatDiscountRatio(item) {
            let targetNameList = [
                '标准取费打折系数',
                '打折系数',
                '比例系数'
            ]
            if(targetNameList.includes(item.describeName)){
                item.describeType = '百分比'
                item.describeUnit = '%'
                item.describeRaito = 0.01
            }
            return item
        },

        getFixedResult() {
            // 判断是否有固定结果但是没有展示
            let targetNameList = [
                '固定结果'
            ]
            return this.getSpecialFormItem(targetNameList, 'describeType')
        },

        // 校验选项是否展示
        checkShowFormItem(item) {
            if(item.describeName == '计算依据') return false
            if(!this.checkFormItem) return true
            if(item.parentId !== '0' && item.describeCondition){
                let target = this.form.formItemList.filter(formItem => formItem.id == item.parentId)[0]
                if(!target.describeValue) return false
                if(target.parentId !== '0' && target.describeCondition){
                    if(this.checkShowFormItem(target)){
                        let targetArr = target.describeValue.split(',')
                        let describeConditionArr = item.describeCondition.split(',')
                        let resultArr = Array.from(new Set([...targetArr, ...describeConditionArr]))
                        return resultArr.length < targetArr.length + describeConditionArr.length
                    }else{
                        return false
                    }
                }else{
                    let targetArr = target.describeValue.split(',')
                    let describeConditionArr = item.describeCondition.split(',')
                    let resultArr = Array.from(new Set([...targetArr, ...describeConditionArr]))
                    return resultArr.length < targetArr.length + describeConditionArr.length
                }
            }else{
                return true
            }
        },

        refreshResult(result) {
            console.log(result)
            this.result = result[0]
            // 工程造价咨询费 特殊结果
            if(result[0].jsMap){
                this.result.jsMap = result[0].jsMap
            }
        },

        getCalculateProgress() {
            let data = JSON.parse(JSON.stringify(this.form))
            if(data.engineeringName == '地质灾害危险性评估'){
                data.eiaType = data.eiaType.join("/")
                data.calculateBase = this.expenses;
            }
            this.$emit('calculateData', [data], this.id)
        },

        handleProvienceChange(data) {
            this.cityName = data.cityName
            if(data.submitFlag) this.submit()
            this.getFormItem()
        },

        // 获取form表单
        getFormItem() {
            this.$get('/web/yzkjhz/hz/detaillist', {
                baseName: this.name,
                cityName: this.cityName,
                isJsq: 2
            }, res => {
                this.checkFormItem = res.filter(item => {
                    return item.describeType == '下拉关联选项' || item.describeType == '下拉树形关联选项'
                }).length > 0
                let result = res.filter(item => {
                    return item.describeName == '计算依据'
                })
                this.basicCriterion = result.length > 0 ? result[0] : {}
                this.result.beforeSummation = 0
                this.result.summation = 0
                // 工程造价咨询费 特殊结果
                if(this.result.jsMap){
                    this.result.jsMap = {}
                }
                this.form.formItemList = res.map((item, index) => {
                    if(item.describeType == '下拉文字多选' || item.describeType == '下拉多选' || item.describeType == '下拉文字多选关联'){
                        item.describeCode = item.describeValue ? item.describeValue.split(',') : []
                    }
                    if(
                        item.describeType == '下拉选项' || 
                        item.describeType == '树形下拉选项' || 
                        item.describeType == '树形下拉数字选项' || 
                        item.describeType == '树形下拉多选选项' || 
                        item.describeType == '树形下拉文字选项' || 
                        item.describeType == '树形下拉关联选项' || 
                        item.describeType == '下拉多选' || 
                        item.describeType == '下拉关联选项' || 
                        item.describeType == '下拉树形关联选项' || 
                        item.describeType == '下拉文字多选' || 
                        item.describeType == '下拉文字多选关联' ||
                        item.describeType == '下拉数字选项'
                    ){
                        item.describeOptionList = []
                        item.describeShowValue = []
                        this.getSelectData(index, item)
                    }
                    item = this.formatDiscountRatio(item)
                    if(item.describeRaito && item.describeValue){
                        item.describeValue = item.describeValue/item.describeRaito
                    }
                    return item 
                })
                this.checkShowFormItemFn()
                this.$emit('updateBasicCriterion', this.name, this.basicCriterion)
            })
        },

        checkShowFormItemFn() {
            this.form.formItemList.map((item, index) => {
                item.showFormItem = this.checkShowFormItem(item)
                return item
            })
            this.result.discountRatio = this.getDiscountRatio()
        },
        findParentPath(dictCode, treeData, path = []) {
            for (let node of treeData) {
                const currentPath = [...path, node]
                
                // 如果当前节点匹配
                if (node.dictCode === dictCode) {
                    return currentPath // 返回完整路径
                }
                
                // 如果有子节点则递归查找
                if (node.children && node.children.length) {
                    const found = this.findParentPath(dictCode, node.children, currentPath)
                    if (found) return found
                }
            }
            return null // 未找到返回null
        },

        getSelectData(index, item) {
            this.$get('/web/yzkjhz/hz/dictlist', {
                baseName: this.name,
                cityName: this.cityName,
                describeName: item.describeName,
                isJsq: 2
            }, res => {
                this.form.formItemList[index].describeOptionList = res
                if(item.describeType == '下拉树形关联选项' && item.describeValue){
                    const path = this.findParentPath(item.describeValue, res)
                    if (path) {
                        this.form.formItemList[index].describeShowValue = path.map(item => item.dictName)
                    }
                }
            })
        },

        submit() {
            let formItemList = JSON.parse(JSON.stringify(this.form.formItemList.filter(item => item.showFormItem))).map(item => {

                item.describeValue = (item.describeRaito == null || !item.describeRaito) ? item.describeValue : item.describeValue*item.describeRaito
                return item
            })
            let data = {
                cityName: this.cityName,
                engineeringName: this.name,
                priceDetailList: formItemList
            }

            this.$refs.form.validate((valid) => {
                if(valid){
                    this.$emit('calculateData', [data], this.id)
                }
            })
        }
    },
    mounted() {
        this.form.engineeringName = this.name
    }
}
</script>
  
<style lang="scss" scoped>
    .dictDetail {
        font-size: 12px;
        line-height: 22px;
        font-weight: normal!important;
        color: red;
        white-space:pre-wrap;
        white-space:-moz-pre-wrap;
        white-space:-pre-wrap;
        white-space:-o-pre-wrap;
        word-wrap:break-word;
        padding-left: 20px;
    }

    .dictContent {
        display: flex;
        overflow: hidden;
        justify-content: space-between;
        .dictName {
            white-space: normal;
        }
        .dictCode {
            margin-left: 40px;
        }
    }

    .dialogBox {
        max-height: 60vh;
        overflow-y: auto;
    }

    .custom-tree-node {
        width: 100%;
        padding-right: 20px;
    }

    ::v-deep .el-form-item__label::before {
        content: ''!important;
    }

    // /deep/.el-form-item__label {
    //     font-weight: 700;
    //     font-size: 16px;
    // }
</style>

<style>
.el-tree-node__content {
    height: auto!important;
    line-height: 30px;
}
</style>